import React, { useEffect, useState } from 'react';

import { Container, Row, Col, Card, CardHeader, CardBody, Alert } from 'reactstrap';

import Page from '../../components/Layout/Page/Page';
import Loader from '../../components/Common/Loader';
import NotificationRow from '../../components/Notifications/NotificationRow';

import { loadNotifications } from '../../helpers/api/notifications.api';

const NotificationsList = (props) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [notifications, setNotifications] = useState([]);

	useEffect(() => {
		setError(false);
		setLoading(true);
		try {
			loadNotifications()
				.then((result) => {
					setLoading(false);
					if (result.success) setNotifications(result.notifications);
					else setError(result.message);
				})
				.catch((error) => {
					setLoading(false);
					setError(error);
				});
		} catch (error) {
			setError(error.message);
			setLoading(false);
		}
	}, []);

	const notificationsRows =
		notifications.lenght > 0 ? (
			notifications.map((n) => <NotificationRow key={n._id.toString()} notification={n} />)
		) : (
			<p>Nessuna notifica</p>
		);

	return <Page className="notifications">
			<Container className="h-100">
				<Row className="h-100">
					<Col md="10" className="h-100 pb-4 pb-lg-0">
						<Card className="h-100">
							<CardHeader>
								<h5>Notifiche</h5>
							</CardHeader>
							<CardBody>
								{loading ? (
									<Loader className="mt-5" />
								) : error ? (
									<Alert className="mb-0" color="danger">
										{error}
									</Alert>
								) : (
									<Container fluid>{notificationsRows}</Container>
								)}
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
	</Page>;
};

export default NotificationsList;
